import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';

import {DateTimeComponent} from './date-time.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import {ValidationMessageModule} from '../../../../formbird-sc-shared/src/lib/components/validation/validation-message.module';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import { default as pjson } from '../../../../../package.json';

@NgModule({
  declarations: [
    DateTimeComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatButtonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    ComponentSetupModule,
    ValidationMessageModule
  ],
  providers: [
    MatDatepickerModule
  ]
  // do not bootstrap the app component when exporting custom elements because an Angular app doesn't run. An ngDoBootstrap
  // function is defined that does nothing.
  // bootstrap: [AppComponent]
})
export class DateTimeModuleNew {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(DateTimeComponent, 'sc-date-time-new', this.injector, pjson.version);
  }
}
